import { render, staticRenderFns } from "./SearchItem.vue?vue&type=template&id=4655a660&"
import script from "./SearchItem.vue?vue&type=script&lang=js&"
export * from "./SearchItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SearchItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports